export const QUEUE_TYPE_OPTIONS = [
  { label: "All Ranked", value: "all_ranked" },
  { label: "Ranked Solo", value: "ranked_solo" },
  { label: "Ranked Flex", value: "ranked_flex" },
  { label: "ARAM", value: "aram" },
  { label: "Normal Blind", value: "normal_blind" },
  { label: "Normal Draft", value: "normal_draft" },
  // { label: "Clash", value: "clash" },
];

export const QUEUE_TYPE_MAP = {
  all_ranked: [420, 440],
  ranked_solo: [420],
  ranked_flex: [440],
  aram: [450],
  normal_blind: [430],
  normal_draft: [400],
  clash: [700],
};

export const RANKED_QUEUE_TYPE_MAP = {
  all_ranked: [420, 440],
  ranked_solo: [420],
  ranked_flex: [440],
};
